import { ProductsPerInsuranceTarget } from '@core/models/products-per-insurance-target.model';
import { Action, createReducer, on } from '@ngrx/store';
import { updateProductsPerInsuranceTarget } from '@redux/actions/recommended-products.actions';

export interface RecommendedProductsState {
  productsPerInsuranceTarget: ProductsPerInsuranceTarget;
}

export const initialRecommendedProductsState: RecommendedProductsState = {
  productsPerInsuranceTarget: {}
};

function deepCloneProductsPerInsuranceTarget(
  productsPerInsuranceTarget: ProductsPerInsuranceTarget
): ProductsPerInsuranceTarget {
  // TODO: use a better approach
  return JSON.parse(JSON.stringify(productsPerInsuranceTarget));
}

const _recommendedProductsReducer = createReducer(
  initialRecommendedProductsState,
  on(updateProductsPerInsuranceTarget, (state, { newProductsPerInsuranceTarget }) => {
    const productsPerInsuranceTarget = deepCloneProductsPerInsuranceTarget(newProductsPerInsuranceTarget);
    return { ...state, productsPerInsuranceTarget };
  })
);

export function recommendedProductsReducer(state: RecommendedProductsState | undefined, action: Action) {
  return _recommendedProductsReducer(state, action);
}
